import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor, FormControl } from '@angular/forms';
import { PageBuilderImageModel } from '../page-builder-image.model';

@Component({
    selector: 'abw-page-builder-image-design',
    templateUrl: './page-builder-image-design.component.html',
    styleUrls: ['./page-builder-image-design.component.scss']
})
export class PageBuilderImageDesignComponent {
    @Input() model: PageBuilderImageModel;
    @Input() value: string;
}